module.exports = __webpack_public_path__ + "static/media/muhammad_atiq-old.14bf4a3e.png";